import constants from '@/libs/constant/constants'
export default {
    data() {
        return {
            claimTo: {},
            active: 0,
            module: constants.PUBLICATION.key
        }
    },
    props: {
        organisationDetails: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        SearchAuthor: () => import(/* webpackChunkName: "org" */ '@/components/pages/Card/Author/SearchAuthor/SearchAuthor.vue'),
        MaintainAuthor: () => import(/* webpackChunkName: "org" */ '@/components/pages/Card/Author/MaintainAuthor/MaintainAuthor.vue'),
        AuthorConfirmation: () => import(/* webpackChunkName: "org" */ '@/components/pages/Card/Author/AuthorConfirmation/AuthorConfirmation.vue'),

    },
    methods: {
        stepForward() {
            if (this.active++ > 5) this.active = 0;
        },
        stepBack(){
            if (this.active -- < 0) this.active = 0;
        },
        setClaimTo(claimTo){
            this.claimTo = claimTo
        },
        cancel (){
            this.$router.push({name: `org-publications`})
        },
    }
}